import axios from 'axios'
import { initNewsGalleries } from './newsGallery'

document.querySelectorAll('[data-load-more]').forEach((loader) => {
  const holder = loader.querySelector('[data-load-more-holder]')
  const triggers = loader.querySelectorAll('[data-load-more-trigger]')
  const pageSize = loader.getAttribute('data-load-more-size')
  const postType = loader.getAttribute('data-load-more-type')

  const urlParams = new URLSearchParams(window.location.search)
  const category = urlParams.get('kategorie')
  // Continue from the page already rendered server-side (?seite=N).
  let page = Math.max(1, parseInt(urlParams.get('seite') || '1', 10))

  const loadMore = async (event) => {
    // The trigger is a real <a href> so it still works without JS; intercept it.
    event?.preventDefault()
    page++

    const { data } = await axios.get(window.php_vars.restUrl + 'glunz/v1/loadmore', {
      params: { pageSize, postType, page, category },
    })

    holder.insertAdjacentHTML('beforeend', data.html)
    initNewsGalleries(holder)

    // Keep ?seite= in the address bar in sync so reloads and SEO scrapers land
    // on the same amount of content, and point the trigger at the next page.
    const url = new URL(window.location.href)
    url.searchParams.set('seite', String(page))
    window.history.replaceState({}, '', url)

    triggers.forEach((trigger) => {
      const href = new URL(trigger.getAttribute('href'), window.location.href)
      href.searchParams.set('seite', String(page + 1))
      trigger.setAttribute('href', href.pathname + href.search)
    })

    if (data.isLastPage) {
      triggers.forEach((trigger) => trigger.classList.add('hidden'))
    }
  }

  triggers.forEach((trigger) => trigger.addEventListener('click', loadMore))
})
